import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageGuard, PageType } from 'src/app/core/services/page-guard.service';
import { FacilitiesEventsComponent } from './events/events.component';
import { FacilitiesComponent } from './facilities.component';
import { FacilitiesIssueComponent } from './issue/issue.component';
import { FacilitiesParkingComponent } from './parking/parking.component';


const routes: Routes = [
    {
        path: '',
        canActivate: [PageGuard],
        component: FacilitiesComponent,
        data: { Page: PageType.Facilities }
    },
    {
        path: 'events',
        canActivate: [PageGuard],
        component: FacilitiesEventsComponent,
        data: { Page: PageType.FacilitiesEvents }
    },
    {
        path: 'issue',
        canActivate: [PageGuard],
        component: FacilitiesIssueComponent,
        data: { Page: PageType.FacilitiesIssue }
    },
    {
        path: 'parking',
        canActivate: [PageGuard],
        component: FacilitiesParkingComponent,
        data: { Page: PageType.ParkingEvents }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FacilitiesRoutingModule { }
